'use strict';

export const lang = {
	FORM: {
		email: 'Email Address',
		cardNumber: 'Card Number',
		expiryDate: 'Expiry Date',
		securityCode: 'CVC Code',
		name: 'Name on card',
		addressPostcodeOrZip: 'ZIP/ postal code',
		currency: 'Currency'
	},
	SCA_REQUIRED_MESSAGE:
		'Your card issuer has asked for further authentication. Please follow the instructions in any popup dialog that may appear. Please wait for us to confirm your payment (do not refresh the page).',
	UPGRADE: 'Your upgrade will apply immediately.',
	VALID_CARD_EXPECTED: 'Purchase with your saved card details or ',
	ADD_NEW_CARD: 'add a new card',
	SAVED_PAYMENT_FAILED:
		'Payment with saved details failed. Please update your card details and try again.'
};
